module.exports = __webpack_public_path__ + "static/media/services.25c79cca.jpg";